import httpClient from "../utils/httpClient";

export const RegistrationData = async (requestParams) => {
  try {
    const response = await httpClient.post(`/Registration/register`, requestParams);
    return response.data;
  } catch (error) {
    console.error("RegistrationData API Error:", error);
    throw error;
  }
};
